<template>
    <header>
        <section class="list-header">
            <nav class="navbar">
                <div class="group-top-left">
                    <button class="burger open_burger" id="menu-toggle" v-on:click="$store.dispatch('toggleMenu')" v-shortkey="['alt', '1']" @shortkey="$store.dispatch('toggleMenu')">
                        <span class="burger_middle_line">  </span>
                    </button>
                    <h5> {{this.appName}} </h5>
                </div>
                <div class="sync-spinner" v-if="$store.getters.dataSyncing">
                  <div class="wave-loader">
                    <div class="layer-1">
                    </div>
                    <div class="layer-2">
                    </div>
                    <div class="layer-3">
                    </div>
                    <div class="layer-4">
                    </div>
                    <div class="layer-5">
                    </div>
                    <div class="layer-6">
                    </div>
                    <div class="layer-7">
                    </div>
                    <div class="layer-8">
                    </div>
                  </div>
                  <span>  Sincronizare date </span>
                </div>
                <div class="log-out">
                    <a href="javascript:void(0)" @click="logout()">
                      {{$t('logout')}}
                        <i class="fas fa-sign-out-alt"></i>
                    </a>
                </div>
            </nav>
        </section>
    </header>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      appName: process.env.VUE_APP_NAME
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('logoutRequest').then((response) => {
        this.$router.push({ name: 'login' })
      })
    }
  }
}
</script>
